import { Col } from '../../components/custom';

export default function FeedbackToAdvantage()
{
    return (
        <Col id='feedbackToAdvantage' className='perspectives'>
            <Col className='banner'>
                <span className='title'>Capturing Product Feedback on Features, Pain Points & Usability</span>
                <span className='desc'>Turn product feedback into your competitive advantage.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Challenge</span>
                <span className='desc bold'>You're building fast — but are you building the right things?</span>
                <span className='descsmall'>As products evolve, so do user expectations. Yet many feedback mechanisms are limited to bug reports or vague NPS scores. Without structured input on specific features, pain points, and usability gaps, product teams risk prioritizing the wrong fixes or missing critical user needs.</span>
            </Col>
            <Col className='section'>
                <span className='title'>Our Philosophy</span>
                <span className='desc bold'>Feedback is your product's second roadmap.</span>
                <span className='descsmall'>We believe in designing intentional feedback loops that go beyond support tickets. By capturing targeted, context-rich product feedback, teams can build what users actually want — not just what they think they need.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Feedback Framework</span>
                <span className='desc'>A feedback system tailored for product insight and iteration:</span>
                <ul>
                    <li className='descsmall'>
                        <strong>Feature-Level Feedback Capture</strong>
                        <ul>
                            <li className='descsmall'>Embed micro-surveys and feedback prompts in-app or post-release.</li>
                            <li className='descsmall'>Target users based on feature usage or specific user flows.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Pain Point Mapping</strong>
                        <ul>
                            <li className='descsmall'>Analyze open-text feedback using NLP to identify common friction points.</li>
                            <li className='descsmall'>Surface issues by frequency, severity, and sentiment — from UI bugs to feature confusion.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Usability Experience Scoring</strong>
                        <ul>
                            <li className='descsmall'>Use task-based feedback and CSAT to measure how intuitive and effective specific workflows are.</li>
                            <li className='descsmall'>Benchmark across product versions or personas.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Loop into Product Prioritization</strong>
                        <ul>
                            <li className='descsmall'>Translate feedback into structured themes and action items for product backlogs.</li>
                            <li className='descsmall'>Align user needs with sprint planning and roadmap discussions.</li>
                        </ul>
                    </li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>What This Enables</span>
                <ul>
                    <li className='descsmall'><strong>Faster Product Iteration</strong> — Detect and address usability issues before they scale.</li>
                    <li className='descsmall'><strong>Customer-Led Roadmapping</strong> — Prioritize features that solve real user problems.</li>
                    <li className='descsmall'><strong>Improved Adoption & Retention</strong> — Remove friction and improve satisfaction where it matters most.</li>
                    <li className='descsmall'><strong>Cross-Functional Visibility</strong> — Give CX, product, and engineering a unified view of feedback themes.</li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>The Takeaway</span>
                <span className='desc bold'>Every piece of feedback is a blueprint for a better product.</span>
                <span className='descsmall'>With structured product feedback capture, teams can innovate with clarity, improve usability with confidence, and deliver experiences that users rave about.</span>
            </Col>
        </Col>
    )
}